var React = require('react');

function PlayIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","d":"M15.82,11.78l-5.2-3c-0.08-0.04-0.17-0.04-0.25,0C10.29,8.83,10.24,8.91,10.24,9v6c0,0.09,0.05,0.17,0.12,0.22\n\tc0.04,0.02,0.08,0.03,0.12,0.03s0.09-0.01,0.12-0.03l1.57-0.91c1.27-0.73,2.75-1.59,3.63-2.09c0.08-0.04,0.12-0.13,0.12-0.22\n\tS15.89,11.83,15.82,11.78z","key":0}),React.createElement("path",{"fill":"currentColor","d":"M12,22C6.49,22,2,17.51,2,12S6.49,2,12,2s10,4.49,10,10S17.51,22,12,22z M12,3.57c-4.65,0-8.43,3.78-8.43,8.43\n\ts3.78,8.43,8.43,8.43s8.43-3.78,8.43-8.43S16.65,3.57,12,3.57z","key":1})]);
}

PlayIcon.defaultProps = {"data-dmid":"dm-play","viewBox":"0 0 24 24","width":"24","height":"24","role":"img","pointerEvents":"none","color":"color2"};

module.exports = PlayIcon;

PlayIcon.default = PlayIcon;
